import React, { useContext, useState } from 'react'
import Autocomplete from '@mui/material/Autocomplete'
import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { UserContext } from '../../../../App'
import API from '../../../../services/API'
import { getEntryById } from '../../../../navigation/registry'
import { getSectionTitle } from '../../../../navigation/sections'
import { useVisiblePages } from '../../../../navigation/useNavigation'

// App preferences tab - saves itself through /account/uipreferences (no
// shared Save button). Currently: the default landing page, i.e. where the
// first visit of each session lands instead of the Home dashboard
// (navigation/RootRedirect.jsx).
const AppPreferences = () => {
  const { user, setUser } = useContext(UserContext)
  const { pages } = useVisiblePages()
  const [saving, setSaving] = useState(false)

  const options = pages.filter((page) => page.path !== '/')
  const current = getEntryById(user?.uiPreferences?.defaultLandingPage) ?? null

  const save = (entry) => {
    setSaving(true)
    API.post('/account/uipreferences', {
      defaultLandingPage: entry?.id ?? null,
    })
      .then((res) => {
        if (res.status === 200) {
          setUser((prev) => ({ ...prev, uiPreferences: res.data }))
        }
      })
      .finally(() => setSaving(false))
  }

  return (
    <Stack spacing={2} maxWidth={480}>
      <Typography variant="subtitle2">Default landing page</Typography>
      <Typography variant="body2" color="text.secondary">
        When you first open AmbuNet, go straight to this page instead of the
        Home dashboard. Home stays a click away in the sidebar.
      </Typography>
      <Autocomplete
        options={options}
        value={options.find((page) => page.id === current?.id) ?? null}
        groupBy={(page) => getSectionTitle(page.section)}
        getOptionLabel={(page) => page.title}
        isOptionEqualToValue={(a, b) => a.id === b.id}
        onChange={(e, value) => save(value)}
        disabled={saving}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            label="Landing page"
            placeholder="Home dashboard (default)"
          />
        )}
      />
    </Stack>
  )
}

export default AppPreferences
